import React from 'react'
export const StandardLaser2 = (props) => {
  const { delivery } = props
  return (
    <>
      {!delivery ? (
        <div className="preview">
          <style>
            {`
              body {
              background: #ddd;
              }
              *, body {
                font-family: "Roboto", sans-serif;
                box-sizing: border-box;
                font-size: 9px;
                color: #000;
                font-weight: 400;
                line-height: 10px;
              }
            `}
          </style>
          <div className="printable" style={{ width: '210mm', margin: '0 auto', background: '#fff' }}>
            <table className="container-preview" cellSpacing={0} cellPadding={0} width="100%" style={{ border: '1px solid #000' }}>
              <tbody>
                <tr>
                  <td style={{ background: '#000', padding: 0, verticalAlign: 'middle' }}>
                    <img src="http://buscrs.com/images/01.png" alt="" />
                  </td>
                  <td style={{ padding: 0 }}>
                    <div>
                      <table style={{ width: '100%' }} className="top-table">
                        <tbody>
                          <tr>
                            <th className="logo-box" rowSpan={2}>
                              <img
                                src="http://buscrs.com/Content/images/Maven-logo.jpg"
                                alt="operator logo"
                                style={{ maxWidth: 140, display: 'block' }}
                              />
                            </th>
                            <th>Booking Date &amp; Time</th>
                            <th>Delivery Type</th>
                            <th>Waybill No.</th>
                            <th>Payment Type</th>
                            <th rowSpan={2}>
                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'space-between',
                                  padding: 3,
                                  fontWeight: 'inherit',
                                }}
                              >
                                <div style={{ fontWeight: 'inherit' }}>
                                  <div style={{ fontWeight: 'inherit' }}>SCAN</div>
                                  <div
                                    style={{
                                      fontWeight: 'inherit',
                                      marginTop: 8,
                                      textAlign: 'left',
                                    }}
                                  >
                                    QR
                                  </div>
                                </div>
                                <img
                                  src="https://cdn.pixabay.com/photo/2013/07/12/14/42/qr-code-148603_1280.png"
                                  alt="qr that can be scanned"
                                  width="28px"
                                  height="28px"
                                  style={{ display: 'block' }}
                                />
                              </div>
                            </th>
                          </tr>
                          <tr>
                            <td>05-07-23, 18:11</td>
                            <td>Home/Godown</td>
                            <td>A/0000123</td>
                            <td>Paid</td>
                          </tr>
                        </tbody>
                      </table>
                      <table>
                        <tbody>
                          <tr>
                            <td style={{ padding: 0, width: '50%' }}>
                              <table className="itenerary-box">
                                <thead>
                                  <tr>
                                    <th style={{ width: '40%' }}>SOURCE CITY</th>
                                    <th style={{ padding: 0 }}>:</th>
                                    <th style={{ width: '60%' }}>Bangalore</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td>CONSIGNER (FROM)</td>
                                    <td style={{ padding: 0 }}>:</td>
                                    <td>Kirtan Pandya</td>
                                  </tr>
                                  <tr>
                                    <td>CONTACT NO.</td>
                                    <td style={{ padding: 0 }}>:</td>
                                    <td>9874563215</td>
                                  </tr>
                                  <tr>
                                    <td>SENDER GSTIN</td>
                                    <td style={{ padding: 0 }}>:</td>
                                    <td>24ABCDE1234F1GH</td>
                                  </tr>
                                </tbody>
                              </table>
                            </td>
                            <td
                              style={{
                                height: '100%',
                                position: 'relative',
                                verticalAlign: 'middle',
                                padding: 0,
                              }}
                            >
                              <div
                                style={{
                                  position: 'absolute',
                                  top: 0,
                                  left: '-1px',
                                  width: 1,
                                  height: '100%',
                                  background: '#000',
                                  zIndex: 1,
                                }}
                              />
                              <svg
                                style={{
                                  position: 'absolute',
                                  zIndex: 1,
                                  background: '#fff',
                                  padding: 2,
                                  left: '-10px',
                                  top: 'calc(50% - 2px)',
                                }}
                                width={18}
                                height={18}
                                viewBox="0 0 20 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M20 10C20 4.48 15.52 0 10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10ZM10 11H6V9H10V6L14 10L10 14V11Z"
                                  fill="black"
                                />
                              </svg>
                            </td>
                            <td style={{ padding: 0, width: '50%' }}>
                              <table className="itenerary-box">
                                <thead>
                                  <tr>
                                    <th className="large-padding-left" style={{ width: '40%' }}>
                                      DESTINATION CITY
                                    </th>
                                    <th style={{ padding: 0 }}>:</th>
                                    <th style={{ width: '60%' }}>Ahmedabad</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td className="large-padding-left">CONSIGNEE (TO)</td>
                                    <td style={{ padding: 0 }}>:</td>
                                    <td>Kirtan Pandya</td>
                                  </tr>
                                  <tr>
                                    <td className="large-padding-left">CONTACT NO.</td>
                                    <td style={{ padding: 0 }}>:</td>
                                    <td>9874563215</td>
                                  </tr>
                                  <tr>
                                    <td className="large-padding-left">RECEIVER GSTIN</td>
                                    <td style={{ padding: 0 }}>:</td>
                                    <td>24ABCDE1234F1GH</td>
                                  </tr>
                                </tbody>
                              </table>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <table className="border-table legal-table">
                        <thead>
                          <tr>
                            <th width="34%">LEGAL COMPLIANCE</th>
                            <th width="33%">GOOD DECLARATION</th>
                            <th width="33%">Total CHARGES</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td style={{ padding: 0 }}>
                              <table className="no-border left-uppercase">
                                <tbody>
                                  <tr>
                                    <td style={{ width: '55%' }}>Party Bill No.</td>
                                    <td style={{ padding: 0 }}>:</td>
                                    <td style={{ width: '45%' }}>JAN/2022/123</td>
                                  </tr>
                                  <tr>
                                    <td>Party Bill DATE</td>
                                    <td style={{ padding: 0 }}>:</td>
                                    <td>23-11-23</td>
                                  </tr>
                                  <tr>
                                    <td>PARTY BILL VALUE</td>
                                    <td style={{ padding: 0 }}>:</td>
                                    <td>15000</td>
                                  </tr>
                                  <tr>
                                    <td>Declared Value</td>
                                    <td style={{ padding: 0 }}>:</td>
                                    <td>5000</td>
                                  </tr>
                                  <tr>
                                    <td>EWAY BILL NO.</td>
                                    <td style={{ padding: 0 }}>:</td>
                                    <td style={{ lineHeight: '10px' }}>
                                      1234 5678 7890, 2345 5678 7890, 1234 5678 7890, 2345 5678 7890, 1234 5678 7890,
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </td>
                            <td style={{ padding: 0 }}>
                              <table className="no-border left-uppercase">
                                <tbody>
                                  <tr>
                                    <td>Item Type</td>
                                    <td style={{ padding: 0 }}>:</td>
                                    <td style={{ width: '40%' }}>Multiple</td>
                                  </tr>
                                  <tr>
                                    <td>Method of packing</td>
                                    <td style={{ padding: 0 }}>:</td>
                                    <td style={{ width: '40%' }}>Multiple</td>
                                  </tr>
                                  <tr>
                                    <td>DESCRIPTION</td>
                                    <td style={{ padding: 0 }}>:</td>
                                    <td style={{ width: '40%' }}>NA</td>
                                  </tr>
                                  <tr>
                                    <td>Total Units</td>
                                    <td style={{ padding: 0 }}>:</td>
                                    <td style={{ width: '40%' }}>10</td>
                                  </tr>
                                  <tr>
                                    <td>Goods VALUE</td>
                                    <td style={{ padding: 0 }}>:</td>
                                    <td style={{ width: '40%' }}>10000</td>
                                  </tr>
                                  <tr>
                                    <td>ActuAL WEIGHT(KG)</td>
                                    <td style={{ padding: 0 }}>:</td>
                                    <td style={{ width: '40%' }}>10</td>
                                  </tr>
                                  <tr>
                                    <td>CHARGE WEIGHT(KG)</td>
                                    <td style={{ padding: 0 }}>:</td>
                                    <td style={{ width: '40%' }}>10</td>
                                  </tr>
                                  <tr>
                                    <td>RATE</td>
                                    <td style={{ padding: 0 }}>:</td>
                                    <td style={{ width: '40%' }}>10/KG</td>
                                  </tr>
                                  <tr>
                                    <td>FREIGHT</td>
                                    <td style={{ padding: 0 }}>:</td>
                                    <td style={{ width: '40%' }}>100</td>
                                  </tr>
                                </tbody>
                              </table>
                            </td>
                            <td style={{ padding: 0 }}>
                              <table className="no-border left-uppercase">
                                <tbody>
                                  <tr>
                                    <td>Total freight</td>
                                    <td style={{ padding: 0 }}>:</td>
                                    <td>11000</td>
                                  </tr>
                                  <tr>
                                    <td>collection cartage</td>
                                    <td style={{ padding: 0 }}>:</td>
                                    <td>10</td>
                                  </tr>
                                  <tr>
                                    <td>delivery Cartage</td>
                                    <td style={{ padding: 0 }}>:</td>
                                    <td>10</td>
                                  </tr>
                                  <tr>
                                    <td>hamali CHARGES</td>
                                    <td style={{ padding: 0 }}>:</td>
                                    <td>10</td>
                                  </tr>
                                  <tr>
                                    <td>ops hamali CHARGES</td>
                                    <td style={{ padding: 0 }}>:</td>
                                    <td>10</td>
                                  </tr>
                                  <tr>
                                    <td>Valuation charges</td>
                                    <td style={{ padding: 0 }}>:</td>
                                    <td>10</td>
                                  </tr>
                                  <tr>
                                    <td>Document charges</td>
                                    <td style={{ padding: 0 }}>:</td>
                                    <td>10</td>
                                  </tr>
                                  <tr>
                                    <td>Pick Up cHARGE</td>
                                    <td style={{ padding: 0 }}>:</td>
                                    <td>10</td>
                                  </tr>
                                  <tr>
                                    <td>DROP OFF charges</td>
                                    <td style={{ padding: 0 }}>:</td>
                                    <td>10</td>
                                  </tr>
                                  <tr>
                                    <td>GST</td>
                                    <td style={{ padding: 0 }}>:</td>
                                    <td>10</td>
                                  </tr>
                                  <tr
                                    style={{
                                      background: '#d9d9d9',
                                      borderTop: '1px solid #000',
                                    }}
                                  >
                                    <td style={{ lineHeight: '14px', fontWeight: 'bold' }}>total amount</td>
                                    <td style={{ padding: 0 }}>:</td>
                                    <td style={{ lineHeight: '14px', fontWeight: 'bold' }}>1,190</td>
                                  </tr>
                                </tbody>
                              </table>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <table className="border-table rules-table">
                        <thead>
                          <tr>
                            <th colSpan={2}>Rules AND Regulations</th>
                            <th colSpan={2}>CONSIGNOR DECLARATION</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td colSpan={2}>
                              <p>
                                1. Parcel / Luggage / Covers are carried at owner's risk. 2. In case the parcels are loss or damaged on
                                transit the Company will not take any liabilities on it. 3. Contraband articles are not permitted to be
                                carried in the vehicles. their agents will bear sole responsibility in case any objectionable / contraband
                                goods are found in the packages on checked by octroi, excise or any other authority .
                              </p>
                            </td>
                            <td colSpan={2}>
                              <p>
                                We hereby agree to the terms and conditions set out on the above of this consignor copy and declare that the
                                contents on this way bill are true and correct. The Topay freight has my/our consent and will be paid by the
                                consignee along with other charges
                              </p>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div>HELPLINE NO: 1234567890</div>
                              <div>WEBSITE: WWW.TRAVELYAARI.COM</div>
                            </td>
                            <td>
                              <div style={{ whiteSpace: 'nowrap' }}>
                                PRINT DATE: <span> 01/12/2022</span>
                              </div>
                              <div>
                                PRINT TIME: <span>19:43</span>
                              </div>
                            </td>
                            <td>
                              CONSIGNOR NAME:
                              <div className="empty-block" />
                            </td>
                            <td>
                              CONSIGNOR SIGN:
                              <div className="empty-block" />
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                  <td style={{ background: '#000', padding: 0, verticalAlign: 'middle' }}>
                    <img src="http://buscrs.com/images/02.png" alt="" />
                  </td>
                </tr>
              </tbody>
            </table>
            <div style={{ width: '100%', padding: 20 }}>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  background: 'repeating-linear-gradient(90deg, transparent, transparent 10px, black 10px, black 20px)',
                  width: '100%',
                  height: 1,
                }}
              >
                <div className="scissor">✂</div>
                <div className="scissor">✂</div>
                <div className="scissor">✂</div>
                <div className="scissor">✂</div>
              </div>
            </div>
            <table className="container-preview" cellSpacing={0} cellPadding={0} width="100%" style={{ border: '1px solid #000' }}>
              <tbody>
                <tr>
                  <td style={{ background: '#000', padding: 0, verticalAlign: 'middle' }}>
                    <img src="http://buscrs.com/images/01.png" alt="" />
                  </td>
                  <td style={{ padding: 0 }}>
                    <div>
                      <table style={{ width: '100%' }} className="top-table">
                        <tbody>
                          <tr>
                            <th className="logo-box" rowSpan={2}>
                              <img
                                src="http://buscrs.com/Content/images/Maven-logo.jpg"
                                alt="operator logo"
                                style={{ maxWidth: 140, display: 'block' }}
                              />
                            </th>
                            <th>Booking Date &amp; Time</th>
                            <th>Delivery Type</th>
                            <th>Waybill No.</th>
                            <th>Payment Type</th>
                            <th rowSpan={2}>
                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'space-between',
                                  padding: 3,
                                  fontWeight: 'inherit',
                                }}
                              >
                                <div style={{ fontWeight: 'inherit' }}>
                                  <div style={{ fontWeight: 'inherit' }}>SCAN</div>
                                  <div
                                    style={{
                                      fontWeight: 'inherit',
                                      marginTop: 8,
                                      textAlign: 'left',
                                    }}
                                  >
                                    QR
                                  </div>
                                </div>
                                <img
                                  src="https://cdn.pixabay.com/photo/2013/07/12/14/42/qr-code-148603_1280.png"
                                  alt="qr that can be scanned"
                                  width="28px"
                                  height="28px"
                                  style={{ display: 'block' }}
                                />
                              </div>
                            </th>
                          </tr>
                          <tr>
                            <td>05-07-23, 18:11</td>
                            <td>Home/Godown</td>
                            <td>A/0000123</td>
                            <td>Paid</td>
                          </tr>
                        </tbody>
                      </table>
                      <table>
                        <tbody>
                          <tr>
                            <td style={{ padding: 0, width: '50%' }}>
                              <table className="itenerary-box">
                                <thead>
                                  <tr>
                                    <th style={{ width: '40%' }}>SOURCE CITY</th>
                                    <th style={{ padding: 0 }}>:</th>
                                    <th style={{ width: '60%' }}>Bangalore</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td>CONSIGNER (FROM)</td>
                                    <td style={{ padding: 0 }}>:</td>
                                    <td>Kirtan Pandya</td>
                                  </tr>
                                  <tr>
                                    <td>CONTACT NO.</td>
                                    <td style={{ padding: 0 }}>:</td>
                                    <td>9874563215</td>
                                  </tr>
                                  <tr>
                                    <td>SENDER GSTIN</td>
                                    <td style={{ padding: 0 }}>:</td>
                                    <td>24ABCDE1234F1GH</td>
                                  </tr>
                                </tbody>
                              </table>
                            </td>
                            <td
                              style={{
                                height: '100%',
                                position: 'relative',
                                verticalAlign: 'middle',
                                padding: 0,
                              }}
                            >
                              <div
                                style={{
                                  position: 'absolute',
                                  top: 0,
                                  left: '-1px',
                                  width: 1,
                                  height: '100%',
                                  background: '#000',
                                  zIndex: 1,
                                }}
                              />
                              <svg
                                style={{
                                  position: 'absolute',
                                  zIndex: 1,
                                  background: '#fff',
                                  padding: 2,
                                  left: '-10px',
                                  top: 'calc(50% - 2px)',
                                }}
                                width={18}
                                height={18}
                                viewBox="0 0 20 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M20 10C20 4.48 15.52 0 10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10ZM10 11H6V9H10V6L14 10L10 14V11Z"
                                  fill="black"
                                />
                              </svg>
                            </td>
                            <td style={{ padding: 0, width: '50%' }}>
                              <table className="itenerary-box">
                                <thead>
                                  <tr>
                                    <th className="large-padding-left" style={{ width: '40%' }}>
                                      DESTINATION CITY
                                    </th>
                                    <th style={{ padding: 0 }}>:</th>
                                    <th style={{ width: '60%' }}>Ahmedabad</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td className="large-padding-left">CONSIGNEE (TO)</td>
                                    <td style={{ padding: 0 }}>:</td>
                                    <td>Kirtan Pandya</td>
                                  </tr>
                                  <tr>
                                    <td className="large-padding-left">CONTACT NO.</td>
                                    <td style={{ padding: 0 }}>:</td>
                                    <td>9874563215</td>
                                  </tr>
                                  <tr>
                                    <td className="large-padding-left">RECEIVER GSTIN</td>
                                    <td style={{ padding: 0 }}>:</td>
                                    <td>24ABCDE1234F1GH</td>
                                  </tr>
                                </tbody>
                              </table>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <table className="border-table legal-table">
                        <thead>
                          <tr>
                            <th width="34%">LEGAL COMPLIANCE</th>
                            <th width="33%">GOOD DECLARATION</th>
                            <th width="33%">Total CHARGES</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td style={{ padding: 0 }}>
                              <table className="no-border left-uppercase">
                                <tbody>
                                  <tr>
                                    <td style={{ width: '55%' }}>Party Bill No.</td>
                                    <td style={{ padding: 0 }}>:</td>
                                    <td style={{ width: '45%' }}>JAN/2022/123</td>
                                  </tr>
                                  <tr>
                                    <td>Party Bill DATE</td>
                                    <td style={{ padding: 0 }}>:</td>
                                    <td>23-11-23</td>
                                  </tr>
                                  <tr>
                                    <td>PARTY BILL VALUE</td>
                                    <td style={{ padding: 0 }}>:</td>
                                    <td>15000</td>
                                  </tr>
                                  <tr>
                                    <td>Declared Value</td>
                                    <td style={{ padding: 0 }}>:</td>
                                    <td>5000</td>
                                  </tr>
                                  <tr>
                                    <td>EWAY BILL NO.</td>
                                    <td style={{ padding: 0 }}>:</td>
                                    <td style={{ lineHeight: '10px' }}>
                                      1234 5678 7890, 2345 5678 7890, 1234 5678 7890, 2345 5678 7890, 1234 5678 7890,
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </td>
                            <td style={{ padding: 0 }}>
                              <table className="no-border left-uppercase">
                                <tbody>
                                  <tr>
                                    <td>Item Type</td>
                                    <td style={{ padding: 0 }}>:</td>
                                    <td style={{ width: '40%' }}>Multiple</td>
                                  </tr>
                                  <tr>
                                    <td>Method of packing</td>
                                    <td style={{ padding: 0 }}>:</td>
                                    <td style={{ width: '40%' }}>Multiple</td>
                                  </tr>
                                  <tr>
                                    <td>DESCRIPTION</td>
                                    <td style={{ padding: 0 }}>:</td>
                                    <td style={{ width: '40%' }}>NA</td>
                                  </tr>
                                  <tr>
                                    <td>Total Units</td>
                                    <td style={{ padding: 0 }}>:</td>
                                    <td style={{ width: '40%' }}>10</td>
                                  </tr>
                                  <tr>
                                    <td>Goods VALUE</td>
                                    <td style={{ padding: 0 }}>:</td>
                                    <td style={{ width: '40%' }}>10000</td>
                                  </tr>
                                  <tr>
                                    <td>ActuAL WEIGHT(KG)</td>
                                    <td style={{ padding: 0 }}>:</td>
                                    <td style={{ width: '40%' }}>10</td>
                                  </tr>
                                  <tr>
                                    <td>CHARGE WEIGHT(KG)</td>
                                    <td style={{ padding: 0 }}>:</td>
                                    <td style={{ width: '40%' }}>10</td>
                                  </tr>
                                  <tr>
                                    <td>RATE</td>
                                    <td style={{ padding: 0 }}>:</td>
                                    <td style={{ width: '40%' }}>10/KG</td>
                                  </tr>
                                  <tr>
                                    <td>FREIGHT</td>
                                    <td style={{ padding: 0 }}>:</td>
                                    <td style={{ width: '40%' }}>100</td>
                                  </tr>
                                </tbody>
                              </table>
                            </td>
                            <td style={{ padding: 0 }}>
                              <table className="no-border left-uppercase">
                                <tbody>
                                  <tr>
                                    <td>Total freight</td>
                                    <td style={{ padding: 0 }}>:</td>
                                    <td>11000</td>
                                  </tr>
                                  <tr>
                                    <td>collection cartage</td>
                                    <td style={{ padding: 0 }}>:</td>
                                    <td>10</td>
                                  </tr>
                                  <tr>
                                    <td>delivery Cartage</td>
                                    <td style={{ padding: 0 }}>:</td>
                                    <td>10</td>
                                  </tr>
                                  <tr>
                                    <td>hamali CHARGES</td>
                                    <td style={{ padding: 0 }}>:</td>
                                    <td>10</td>
                                  </tr>
                                  <tr>
                                    <td>ops hamali CHARGES</td>
                                    <td style={{ padding: 0 }}>:</td>
                                    <td>10</td>
                                  </tr>
                                  <tr>
                                    <td>Valuation charges</td>
                                    <td style={{ padding: 0 }}>:</td>
                                    <td>10</td>
                                  </tr>
                                  <tr>
                                    <td>Document charges</td>
                                    <td style={{ padding: 0 }}>:</td>
                                    <td>10</td>
                                  </tr>
                                  <tr>
                                    <td>Pick Up cHARGE</td>
                                    <td style={{ padding: 0 }}>:</td>
                                    <td>10</td>
                                  </tr>
                                  <tr>
                                    <td>DROP OFF charges</td>
                                    <td style={{ padding: 0 }}>:</td>
                                    <td>10</td>
                                  </tr>
                                  <tr>
                                    <td>GST</td>
                                    <td style={{ padding: 0 }}>:</td>
                                    <td>10</td>
                                  </tr>
                                  <tr
                                    style={{
                                      background: '#d9d9d9',
                                      borderTop: '1px solid #000',
                                    }}
                                  >
                                    <td style={{ lineHeight: '14px', fontWeight: 'bold' }}>total amount</td>
                                    <td style={{ padding: 0 }}>:</td>
                                    <td style={{ lineHeight: '14px', fontWeight: 'bold' }}>1,190</td>
                                  </tr>
                                </tbody>
                              </table>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <table className="border-table rules-table">
                        <thead>
                          <tr>
                            <th colSpan={2}>Rules AND Regulations</th>
                            <th colSpan={2}>CONSIGNOR DECLARATION</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td colSpan={2}>
                              <p>
                                1. Parcel / Luggage / Covers are carried at owner's risk. 2. In case the parcels are loss or damaged on
                                transit the Company will not take any liabilities on it. 3. Contraband articles are not permitted to be
                                carried in the vehicles. their agents will bear sole responsibility in case any objectionable / contraband
                                goods are found in the packages on checked by octroi, excise or any other authority .
                              </p>
                            </td>
                            <td colSpan={2}>
                              <p>
                                We hereby agree to the terms and conditions set out on the above of this consignor copy and declare that the
                                contents on this way bill are true and correct. The Topay freight has my/our consent and will be paid by the
                                consignee along with other charges
                              </p>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div>HELPLINE NO: 1234567890</div>
                              <div>WEBSITE: WWW.TRAVELYAARI.COM</div>
                            </td>
                            <td>
                              <div style={{ whiteSpace: 'nowrap' }}>
                                PRINT DATE: <span> 01/12/2022</span>
                              </div>
                              <div>
                                PRINT TIME: <span>19:43</span>
                              </div>
                            </td>
                            <td>
                              CONSIGNOR NAME:
                              <div className="empty-block" />
                            </td>
                            <td>
                              CONSIGNOR SIGN:
                              <div className="empty-block" />
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                  <td style={{ background: '#000', padding: 0, verticalAlign: 'middle' }}>
                    <img src="http://buscrs.com/images/02.png" alt="" />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      ) : (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', fontSize: '25px' }}>
          Coming Soon
        </div>
      )}
    </>
  )
}
